import api, { setAdminToken } from '../api'

export async function loginWithPassword(phone, password) {
  const res = await api.post('/auth/login/password/backoffice', { phone, password })
  return res.data
}

export async function fetchMe() {
  const res = await api.get('/auth/me')
  return res.data
}

export async function fetchDashboardStats() {
  const res = await api.get('/admin/dashboard')
  return res.data
}

export async function searchArtisans(q = '', status = '') {
  const params = { q }
  if (status) params.status = status
  const res = await api.get('/admin/artisans', { params })
  return res.data
}

export async function approveArtisan(artisanId) {
  const res = await api.patch(`/admin/artisans/${artisanId}/approve`)
  return res.data
}

export async function rejectArtisan(artisanId) {
  const res = await api.patch(`/admin/artisans/${artisanId}/reject`)
  return res.data
}

export async function listCategories() {
  const res = await api.get('/categories', { params: { include_inactive: true } })
  return res.data
}

export async function createCategory(payload) {
  const res = await api.post('/categories', payload)
  return res.data
}

export async function deleteCategory(categoryId) {
  const res = await api.delete(`/categories/${categoryId}`)
  return res.data
}

export async function reactivateCategory(categoryId) {
  const res = await api.patch(`/categories/${categoryId}`, { is_active: true })
  return res.data
}

export async function listFraudAlerts(q = '', status = '', type = '') {
  const params = {}
  if (q) params.q = q
  if (status) params.status = status
  if (type) params.type = type
  const res = await api.get('/admin/fraud-alerts', { params })
  return res.data
}

export async function resolveFraudAlert(alertId, payload) {
  const res = await api.patch(`/admin/fraud-alerts/${alertId}`, payload)
  return res.data
}

export async function listFraudAlertEvents(alertId) {
  const res = await api.get(`/admin/fraud-alerts/${alertId}/events`)
  return res.data
}

export async function getFraudPolicy() {
  const res = await api.get('/admin/fraud-policy')
  return res.data
}

export async function updateFraudPolicy(payload) {
  const res = await api.patch('/admin/fraud-policy', payload)
  return res.data
}

export async function getFraudAnalytics() {
  const res = await api.get('/admin/fraud-analytics')
  return res.data
}

export async function setArtisanSanction(artisanId, payload) {
  const res = await api.patch(`/admin/artisans/${artisanId}/sanction`, payload)
  return res.data
}

export async function listDisputes(q = '', status = '') {
  const params = {}
  if (q) params.q = q
  if (status) params.status = status
  const res = await api.get('/admin/disputes', { params })
  return res.data
}

export async function resolveDispute(disputeId, payload) {
  const res = await api.patch(`/admin/disputes/${disputeId}`, payload)
  return res.data
}

export async function adminTransfer(amount, phone, description = 'Virement admin ProFissa') {
  const res = await api.post('/admin/finance/transfer', { amount, phone, description })
  return res.data
}

export async function listSavTickets(q = '', status = '') {
  const params = {}
  if (q) params.q = q
  if (status) params.status = status
  const res = await api.get('/admin/sav', { params })
  return res.data
}

export async function resolveSavTicket(ticketId, payload) {
  const res = await api.patch(`/admin/sav/${ticketId}`, payload)
  return res.data
}

export async function listInterventions(q = '', status = '', category = '') {
  const params = {}
  if (q) params.q = q
  if (status) params.status = status
  if (category) params.category = category
  const res = await api.get('/admin/interventions', { params })
  return res.data
}

export async function listWaitlistRequests() {
  const res = await api.get('/admin/waitlist')
  return res.data
}

export async function assignWaitlistRequest(requestId, artisanId) {
  const res = await api.post(`/admin/waitlist/${requestId}/assign`, { artisan_id: artisanId })
  return res.data
}

export async function fetchChatMessages(interventionId, limit = 50) {
  const res = await api.get(`/admin/chat/${interventionId}/messages`, { params: { limit } })
  return res.data
}

export async function updateCategory(id, payload) {
  const res = await api.patch(`/categories/${id}`, payload)
  return res.data
}

export async function requestArtisanModification(artisanId, notes) {
  const res = await api.post(`/admin/artisans/${artisanId}/request-modification`, { notes })
  return res.data
}

export async function getInterventionDetail(interventionId) {
  const res = await api.get(`/admin/interventions/${interventionId}`)
  return res.data
}

export async function forceCloseIntervention(interventionId) {
  const res = await api.post(`/admin/interventions/${interventionId}/force-close`)
  return res.data
}

export async function listClients(q = '', isActive = null) {
  const params = {}
  if (q) params.q = q
  if (isActive != null) params.is_active = isActive
  const res = await api.get('/admin/clients', { params })
  return res.data
}

export async function toggleClientActive(userId) {
  const res = await api.patch(`/admin/clients/${userId}/toggle-active`)
  return res.data
}

export async function listTransactions(fromDate = null, toDate = null) {
  const params = {}
  if (fromDate) params.from_date = fromDate
  if (toDate) params.to_date = toDate
  const res = await api.get('/admin/transactions', { params })
  return res.data
}

export async function listWithdrawalRequests(status = '') {
  const params = {}
  if (status) params.status = status
  const res = await api.get('/admin/withdrawal-requests', { params })
  return res.data
}

export async function createWithdrawalRequest(artisanId, amount) {
  const res = await api.post('/admin/withdrawal-requests', { artisan_id: artisanId, amount })
  return res.data
}

export async function processWithdrawalRequest(requestId, approve, adminNotes = '') {
  const res = await api.patch(`/admin/withdrawal-requests/${requestId}/process`, {
    approve,
    admin_notes: adminNotes,
  })
  return res.data
}

export async function getArtisanWallets() {
  const res = await api.get('/admin/artisan-wallets')
  return res.data
}

export async function getFinanceReconciliation() {
  const res = await api.get('/admin/finance/reconciliation')
  return res.data
}

export async function getArtisanTransactions(artisanId) {
  const res = await api.get(`/admin/artisans/${artisanId}/transactions`)
  return res.data
}

export async function getClientEscrowHistory(userId) {
  const res = await api.get(`/admin/clients/${userId}/transactions`)
  return res.data
}

export async function rollbackTransaction(transactionId, reason) {
  const res = await api.post(`/admin/transactions/${transactionId}/rollback`, { reason })
  return res.data
}

export async function getSmsPolicy() {
  const res = await api.get('/admin/sms-policy')
  return res.data
}

export async function updateSmsPolicy(payload) {
  const res = await api.patch('/admin/sms-policy', payload)
  return res.data
}

export async function listSmsLogs(params = {}) {
  const res = await api.get('/admin/sms-logs', { params })
  return res.data
}

export async function sendSmsBroadcast(payload) {
  const { data } = await api.post('/admin/sms-broadcast', payload)
  return data
}

// Push Center endpoints
export async function listPushLogs(params = {}) {
  const { data } = await api.get('/admin/push-logs', { params })
  return data
}

export async function sendPushBroadcast(payload) {
  const { data } = await api.post('/admin/push-broadcast', payload)
  return data
}

export async function listAllUsers(q = '', role = '') {
  const params = {}
  if (q) params.q = q
  if (role) params.role = role
  const res = await api.get('/admin/users', { params })
  return res.data
}

export async function getUserDetail(userId) {
  const res = await api.get(`/admin/users/${userId}`)
  return res.data
}

export async function getUserActivity(userId) {
  const res = await api.get(`/admin/users/${userId}/activity`)
  return res.data
}

export async function listUserAdminNotes(userId) {
  const res = await api.get(`/admin/users/${userId}/notes`)
  return res.data
}

export async function createUserAdminNote(userId, payload) {
  const res = await api.post(`/admin/users/${userId}/notes`, payload)
  return res.data
}

export async function updateUserAdminNote(userId, noteId, payload) {
  const res = await api.patch(`/admin/users/${userId}/notes/${noteId}`, payload)
  return res.data
}

export async function deleteUserAdminNote(userId, noteId) {
  const res = await api.delete(`/admin/users/${userId}/notes/${noteId}`)
  return res.data
}

export async function createUser(payload) {
  const res = await api.post('/admin/users', payload)
  return res.data
}

export async function updateUser(userId, payload) {
  const res = await api.patch(`/admin/users/${userId}`, payload)
  return res.data
}

export async function deleteUser(userId) {
  const res = await api.delete(`/admin/users/${userId}`)
  return res.data
}

export async function listPermissions() {
  const res = await api.get('/admin/permissions')
  return res.data
}

export async function getUserPermissions(userId) {
  const res = await api.get(`/admin/users/${userId}/permissions`)
  return res.data
}

export async function updateUserPermissions(userId, permissions) {
  const res = await api.put(`/admin/users/${userId}/permissions`, { permissions })
  return res.data
}

export async function searchChatInterventions(q = '') {
  const params = {}
  if (q) params.q = q
  const res = await api.get('/admin/chat/search', { params })
  return res.data
}

export async function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  const res = await api.post('/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return res.data
}

export async function listAuditLogs({ limit = 50, offset = 0, action, userId, fromDate, toDate } = {}) {
  const params = { limit, offset }
  if (action) params.action = action
  if (userId) params.user_id = userId
  if (fromDate) params.from_date = fromDate
  if (toDate) params.to_date = toDate
  const res = await api.get('/admin/audit-logs', { params })
  return res.data
}

export async function releaseEscrow(interventionId, mode = 'all') {
  const res = await api.post(`/payments/interventions/${interventionId}/release`, { mode })
  return res.data
}

export async function refundEscrow(interventionId) {
  const res = await api.post(`/payments/interventions/${interventionId}/refund`)
  return res.data
}

// ── Promo Codes ──────────────────────────────────────────────────────────────
export async function listPromoCodes() {
  const res = await api.get('/promo-codes/admin')
  return res.data
}

export async function createPromoCode(payload) {
  const res = await api.post('/promo-codes/admin', payload)
  return res.data
}

export async function updatePromoCode(codeId, payload) {
  const res = await api.patch(`/promo-codes/admin/${codeId}`, payload)
  return res.data
}

export async function deletePromoCode(codeId) {
  await api.delete(`/promo-codes/admin/${codeId}`)
}

// ── Organizations (B2B) ───────────────────────────────────────────────────────
export async function listOrganizations({ org_type } = {}) {
  const params = {}
  if (org_type) params.org_type = org_type
  const res = await api.get('/organizations/admin', { params })
  return res.data
}

export async function getOrgMembers(orgId) {
  const res = await api.get(`/organizations/admin/${orgId}/members`)
  return res.data
}

export async function getOrgRequests(orgId) {
  const res = await api.get(`/organizations/admin/${orgId}/requests`)
  return res.data
}

export async function updateOrganization(orgId, data) {
  const res = await api.patch(`/organizations/admin/${orgId}`, data)
  return res.data
}

export async function listArtisanBusinesses() {
  return listOrganizations({ org_type: 'artisan' })
}

export async function getBusinessEmployees(businessId) {
  // Members of an artisan business are the employee artisans
  return getOrgMembers(businessId)
}

export async function getBusinessMissions(businessId) {
  return getOrgRequests(businessId)
}

// ── Support Dispatch ──────────────────────────────────────────────────────────

export async function supportSearchUsers(phone) {
  const res = await api.get('/admin/support/users/search', { params: { phone } })
  return res.data
}

export async function supportAvailableArtisans(categoryId = '') {
  const params = {}
  if (categoryId) params.category_id = categoryId
  const res = await api.get('/admin/support/artisans/available', { params })
  return res.data
}

export async function supportDispatch(payload) {
  const res = await api.post('/admin/dispatch', payload)
  return res.data
}

// Reports
export async function fetchReports(status = '') {
  const params = {}
  if (status) params.status = status
  const res = await api.get('/admin/reports', { params })
  return res.data
}

export async function updateReportStatus(reportId, status) {
  const res = await api.patch(`/admin/reports/${reportId}`, null, { params: { status } })
  return res.data
}

// ── Profile & Platform Settings ───────────────────────────────────────────────

export async function changeMyPassword(payload) {
  const res = await api.post('/auth/change-password', payload)
  if (res.data?.access_token) {
    setAdminToken(res.data.access_token, res.data.refresh_token)
  }
  return res.data
}

export async function fetchPlatformSettings() {
  const res = await api.get('/admin/settings')
  return res.data
}

export async function updatePlatformSettings(payload) {
  const res = await api.patch('/admin/settings', payload)
  return res.data
}
